module.exports = __webpack_public_path__ + "static/media/women-with-baby.bb3a4eaf.png";